import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useFormikContext } from 'formik';
import { intercomEvent } from '../../../utils/IntercomUtils';

type IntercomFormEventHandlerProps = {
  segment: string;
  partNr: string;
  brandCode: string;
  useHookForm?: boolean;
};

const IntercomFormEventHandler: React.FC<IntercomFormEventHandlerProps> = ({
  segment,
  partNr,
  brandCode,
  useHookForm,
}) => {
  const hookFormContext = useFormContext();
  const formikContext = useFormikContext();

  const currentDirty = useHookForm ? hookFormContext?.formState?.isDirty : formikContext?.dirty;

  const prevDirtyRef = React.useRef<boolean>(false);
  useEffect(() => {
    if (!prevDirtyRef.current && currentDirty) {
      intercomEvent('viewed-all-product', {
        action: 'item-edited',
        location: segment,
        part_number: partNr,
        brand_code: brandCode,
      });
    }
  }, [currentDirty, segment, partNr, brandCode]);

  useEffect(() => {
    prevDirtyRef.current = currentDirty;
  }, [currentDirty]);

  return null;
};

export default IntercomFormEventHandler;
